<template lang="pug">
.analysisEvent
  header
    el-select.group(v-model="params.groups" :placeholder="$t('Analysis.Event.select_group')" size="small" multiple)
      el-option(v-for="group in groups" :key="group.id" :label="group.name" :value="group.id")
    el-select.event(v-model="params.events" :placeholder="$t('Analysis.Event.select_event')" size="small" multiple)
      el-option(v-for="event in events" :key="event.id" :label="event.name" :value="event.id")
    el-date-picker.picker(v-model="params.daterange" type="daterange" size="small" align="right" unlink-panels range-separator="〜" :start-placeholder="$t('Analysis.start_date')" :end-placeholder="$t('Analysis.end_date')" :picker-options="options" :value-format="'yyyy-MM-dd'")

  #graphs
    .action-graph
      h1 {{ $t('Analysis.Event.title01') }}
      el-switch.mode(v-model="modeActionType" active-color="#009CE1" inactive-color="#009CE1"
        :active-text="$t('Analysis.Event.rate')" :inactive-text="$t('Analysis.Event.number')")
      Event(:height="320" :eventCountsByActionTypeByDay="api.eventCountsByActionTypeByDay"
        :percentageMode="modeActionType")

    .event-graph
      h1 {{ $t('Analysis.Event.title-event-graph') }}
      el-switch.mode(v-model="modeEvent" active-color="#009CE1" inactive-color="#009CE1"
        :active-text="$t('Analysis.Event.rate')" :inactive-text="$t('Analysis.Event.number')")
      counts-by-event(:height="320" :eventCountsByEventByDay="api.eventCountsByEventByDay" :eventList="api.eventList"
        :percentageMode="modeEvent")

    EventList(:actions="params.actions" :groups="params.groups" :daterange="params.daterange" :eventFilters="params.events")

</template>

<script>
import actions from '@/utils/defines/actions.js';
import Event from './TotalEvent';
import EventList from './EventList';
import CountsByEvent from './CountsByEvent';
import API from '@/api/analytics';
import EventApi from '@/api/event';
import GroupApi from '@/api/group';
import { mapState } from 'vuex';
export default {
  components: { Event, EventList, CountsByEvent },
  data() {
    return {
      beforeMount: false,
      modeActionType: false,
      modeEvent: false,
      events: [],
      groups: [],
      params: {
        groups: [],
        events: [],
        daterange: []
      },
      options: {
        shortcuts: [{
          text: this.$t('Analysis.last_week'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.last_month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.past_3month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      api: {
        eventCountsByActionTypeByDay: { },
        eventCountsByGroupByDay: { },
        eventCountsByEventByDay: { },
        eventList: [ ]
      }
    }
  },
  title() {
    return this.$t('menus.event')
  },
  mixins: [actions],
  computed: {
    ...mapState({
      analysisFilters: state => state.analysis.analysisFilters
    }),
  },
  beforeMount() {
    this.beforeMount = true;
    this.params = this.analysisFilters;
  },
  mounted() {
    this.$nextTick(function () {
      this.beforeMount = false;
      this.updateChartData();
      this.getEventsGroups();
    });
  },
  methods: {
    getEventsGroups: function (){
      const that = this;
      Promise.all([EventApi.getEvents(), GroupApi.getGroups()])
        .then(function(values) {
          that.events = values[0];
          that.groups = values[1];
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.failed_get'),
            type: 'error'
          });
        })
    },
    updateChartData: function() {
      if(this.beforeMount) return;
      this.$store.commit('setAnalysisFilters', this.params);
      const obj = this;
      const reqParams = {
        daterange: this.params.daterange,
        groups: this.params.groups,
        events: this.params.events
      };
      API.getEventCountsByActionType(reqParams).then(function(response) {
        if (response && response.event_counts) {
          obj.api.eventCountsByActionTypeByDay = response.event_counts
        } else {
          obj.api.eventCountsByActionTypeByDay = { }
        }
      });
      API.getEventCountsByEvent(reqParams).then(function(response) {
        if (response && response.event_counts_by_event) {
          obj.api.eventCountsByEventByDay = response.event_counts_by_event;
        } else {
          obj.api.eventCountsByEventByDay = {};
        }
        if (response && response.event_list) {
          obj.api.eventList = response.event_list
        } else {
          obj.api.eventList = []
        }
      });
    }
  },
  watch: {
    params: {
      handler: function() {
        this.updateChartData();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.analysisEvent {
  padding-top: 80px;

  header {
    position: fixed;
    z-index: 100;
    width: calc(100vw - 320px);
    margin-top: -80px;
    background: #FEFEFE;
    padding: 15px 40px;
    border-bottom: 1px solid $border;

    .action, .group {
      width: 240px;
      margin: 0 20px 0 0;
    }
    .picker {
      width: 280px;
      float: right;
    }
  }

  #graphs {
    background: #FFF;
    margin: 20px 40px;
    border: 1px solid $border;
    border-radius: 5px;
    padding-bottom: 40px;

    .action-graph,
    .event-graph,
    .group-graph {
      padding: 30px 40px;
      position: relative;

      h1 {
        display: block;
        padding: 0;
        margin: 0 0 20px 0;
        font-size: 16px;
        font-weight: normal;
      }
      .mode {
        position: absolute;
        right: 45px;
        top: 34px;
      }
    }
  }
}

span.count {
  display: inline-block;
  text-align: center;
  background: $border;
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 15px;
  margin-left: 8px;
}

</style>

